// tslint:disable: max-classes-per-file

export type FormPermissionFilterPredicate = (permission: FormPermission) => boolean;

export class FormPermissionFilter {
    public readonly filters: FormPermissionFilterPredicate[];

    public get matchingPredicate(): FormPermissionFilterPredicate {
        return (perm) => {
            const passes = this.filters.reduce((result, filter) => {
                if (!result) { return result; }
                return filter(perm);
            }, true);
            return passes;
        };
    }

    public get notMatchingPredicate(): FormPermissionFilterPredicate {
        return (permission) => !this.matchingPredicate(permission);
    }

    public constructor(fieldID?: string, roleID?: string, stateID?: string) {
        this.filters = [];
        if (fieldID) { this.filters.push(p => p.object === fieldID); }
        if (roleID) { this.filters.push(p => p.role === roleID); }
        if (stateID) { this.filters.push(p => p.state === stateID); }
    }
}

export class FormPermission {
    public readonly object: string;
    public readonly state: string;
    public readonly role: string;
    public readonly visible: boolean;
    public readonly editable: boolean;

    constructor(object: string,
                role: string,
                state: string,
                visible: boolean = true,
                editable: boolean = false) {
      this.object = object;
      this.role = role;
      this.state = state;
      this.visible = visible;
      this.editable = editable;
    }
}
